module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "philosophy"
    }
  }, [_c('h2', [_vm._v("A health global approach based on prevention")]), _vm._v(" "), _c('div', {
    staticClass: "philosophy"
  }, [_c('h3', [_vm._v("Nutrion")]), _vm._v(" "), _c('h3', [_vm._v("Behaviour")]), _vm._v(" "), _c('h3', [_vm._v("Homeopathy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b4d976e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/En/Philosophy.vue
// module id = 126
// module chunks = 0